import { render, staticRenderFns } from "./LinhaDialog.vue?vue&type=template&id=12b11a49&scoped=true&"
import script from "./LinhaDialog.vue?vue&type=script&lang=js&"
export * from "./LinhaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b11a49",
  null
  
)

export default component.exports